<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to main" @click="$router.push('/myteam/charges')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>                    
                    <v-spacer></v-spacer>
                    <help-link appId="projects" pageId="project-charges-weekly-review" color="white"></help-link>
                </v-toolbar>
            </v-card>
            <v-card v-if="!loading" class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <v-text-field v-model="search" append-icon="search" label="Search name" single-line hide-details style="margin-bottom:15px;"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn icon small title="View previous week"  @click="viewPrevious" style="margin-right:10px;" :disabled="loading||disablePrev">
                        <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <b>{{weekCoverageDesc.from}} to {{weekCoverageDesc.to}}</b>
                    <v-btn icon small title="View next week" @click="viewNext" :disabled="loading||disableNext">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>  
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="weekly_team_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewDetails(props.item)" style="cursor:pointer;" title="Click to view details">
                            <td>
                                <v-chip style="margin:-5px 0px 0px -5px;">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>{{ props.item.projectChargesHours }}</td>
                            <td>{{ props.item.overtimeHours }}</td>
                            <td>{{ props.item.timeOffHours }}</td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>
    </v-layout> 
</template>

<script>

import projectChargesApi from '@/api/projectcharges'
import cutoffApi from '@/api/cutoff'
import commonfn from '@/common/functions'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'ProjectCharges',
    metaInfo: {
        title: 'Project Charges',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
             paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text: 'Employee',align: 'left',value: 'lastName', width: '35%', sortable:true},
                {text: 'Project Hours',align: 'left',value: 'projectChargesHours', width:'20%', sortable:true},
                {text: 'Overtime Hours',align: 'left',value: 'overtimeHours', width:'20%', sortable:true},
                {text: 'TimeOff Hours',align: 'left',value: 'timeOffHours', width:'20%', sortable:true}
            ],
            weekly_team_summary: [],
            header_data: null,
            cutoff_dates: null,
            search: null,
            menu_status: false,
            selectedWeekNo: null
        }
    },
    methods: {
        async viewPrevious() {
            this.selectedWeekNo--
            this.$router.push(`/myteam/charges/weekly/${this.selectedFiscalYear}/${this.selectedWeekNo}`)
            await this.getWeeklyDetailsByTeam(false)
        },
        async viewNext() {
            this.selectedWeekNo++
            this.$router.push(`/myteam/charges/weekly/${this.selectedFiscalYear}/${this.selectedWeekNo}`)
            await this.getWeeklyDetailsByTeam(false)
        },
        viewDetails(data) {
            this.$router.push(`${this.selectedWeekNo}/${data.userId}`)
        },  
        async getWeeklyDetailsByTeam(display_loading) {
            try {
                this.loading = display_loading
                var data = {
                    fiscalYear: this.selectedFiscalYear,
                    weekNo: this.selectedWeekNo
                }
                const response = await projectChargesApi.getWeeklyDetailsByTeam(data)     
                if (response && response.status == 200) {
                    this.header_data = response.data.header
                    this.weekly_team_summary = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
        async getCutoffSettings(show_loading) {
            try {
                this.loading = show_loading
                const response = await cutoffApi.getByCompany()
                if (response && response.status==200) {
                    this.cutoff_dates = response.data.items.filter(x => {
                        return x.fiscalYear == this.selectedFiscalYear
                    })
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    async created() {
        this.selectedWeekNo = this.$route.params.weekNo
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Team Project Charges'
        })

        await this.getWeeklyDetailsByTeam(true)
        await this.getCutoffSettings(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        selectedFiscalYear() {
            return this.$route.params.fiscalYear
        },
        weekly_team_summary_filtered() {
            var temp = this.weekly_team_summary

            //search 
            if (this.search) {
                temp = temp.filter(item => {
                    return item.firstName.toLowerCase().includes(this.search.toLowerCase()) || 
                            item.lastName.toLowerCase().includes(this.search.toLowerCase())
                })
            }
            return temp
        },
        weekCoverageDesc() {
            if (!this.loading)
                return {
                    from: this.$moment(this.header_data[0].transDate).format('MMM DD, YYYY'),
                    to: this.$moment(this.header_data[this.header_data.length-1].transDate).format('MMM DD, YYYY')
                }
        },
        disablePrev() {
            return this.selectedWeekNo==1
        },
        disableNext() {
            if (!this.loading && this.cutoff_dates!=null)
                return this.$moment(this.weekCoverageDesc.to) >= this.$moment(this.cutoff_dates[0].cutoffEnd) 
        },
    }
}
</script>